<!-- Adapted from YesPlayMusic v0.4.11 views/artistMV.vue, MIT, qier222. Anonymous API does not provide MV playback. -->
<template>
  <section v-if="salt" class="salt-mv-page"><h1>音乐视频</h1><SaltCard><SaltItem title="音乐视频暂不可用" description="此来源未提供 MV 列表及播放接口。" /><SaltItem title="返回艺术家" clickable arrow="arrow" @click="$router.push('/artist/' + $route.params.id)" /></SaltCard></section>
  <div v-else class="artist-mv-page">
    <h1><img class="avatar" :src="runtime.cover()" alt="" loading="lazy" />音乐视频</h1>
    <MvRow :mvs="[]" subtitle="publishTime" />
    <p class="empty-state">此来源未提供 MV 列表及播放接口。</p>
    <router-link class="plain-button" :to="'/artist/' + $route.params.id">返回艺术家</router-link>
  </div>
</template>
<script>
import {runtime} from '../bridge';
import MvRow from '../components/MvRow.vue';
import { workspace } from '../workspace';
import SaltCard from '../salt/ui/SaltCard.vue';
import SaltItem from '../salt/ui/SaltItem.vue';
export default {name:'ArtistMV',components:{MvRow,SaltCard,SaltItem},data(){return {runtime,workspace}},computed:{salt(){return this.workspace.appearance==='salt';}}};
</script>
<style lang="scss" scoped>
.salt-mv-page h1 { margin:0 0 20px;font-size:24px;font-weight:400;color:var(--salt-text); }
h1 {
  font-size: 42px;
  color: var(--color-text);
  .avatar {
    height: 44px;
    margin-right: 12px;
    vertical-align: -7px;
    border-radius: 50%;
    border: rgba(0, 0, 0, 0.2);
  }
}
.load-more {
  display: flex;
  justify-content: center;
}
</style>
